import React, { useContext, useState } from "react";
import AppContext from "../components/AppContext";
import Spinner from '../components/Spinner';

function GlobalSpinner() {
	const appContext = useContext(AppContext);
	const [globalSpinnerCount, setGlobalSpinnerCount] = useState(0);
	appContext.globalSpinnerCount = globalSpinnerCount;
	appContext.setGlobalSpinnerCount = setGlobalSpinnerCount;
 
	return <Spinner show={appContext.globalSpinnerCount > 0} />;
}

export default GlobalSpinner;